import { HashRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import Header from "@Header";
import Footer from "@Footer";
import EmptyFooter from "../Footer/EmptyFooter";
import Toast from "@Comp/Toast";
import routesJson from '@LayOut/Routes/Routes.json'
import React, { Suspense, useEffect, useRef, useState } from 'react';
import ReactGa from 'react-ga4';

import Employment from '@Views/app/Employment/Employment';
import EmploymentWrite from '@Views/app/Employment/EmploymentWrite';

import { getLanguage, isEmpty } from '@Views/utils/StringUtils';
import NotFound from './NotFound';

const Body = ({ userInfo, getMsg, setUserInfo }: any) => {
  const history = useHistory();
  const bodyRef = useRef<any>();

  const getRoute = () => {

    const result: any = [];
    const json: any = routesJson;
    const language = getLanguage();

    for (const key of Object.keys(json)) {

      const href = json[key]['href'];
      if (!href) {
        const url = json[key]['url'];
        const params = json[key]['params'];
        const subMenu = json[key]['menu'];

        if (subMenu) {

          for (const item of subMenu) {
            const menuUrl = url + '/' + item['url'];
            const Comp = React.lazy(() => import('@Views/app/' + menuUrl));
            const path = '/' + menuUrl;

            if (item['lang'].indexOf(language) === -1) {
              continue;
            }

            if (item['params']) {
              for (const param of item['params']) {
                const paramPath = path + param;
                result.push(<Route exact key={paramPath} path={paramPath} render={() => <Comp url={menuUrl} msg={getMsg(menuUrl)} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
              }
            }

            result.push(<Route key={path} exact path={path} render={() => <Comp url={menuUrl} msg={getMsg(menuUrl)} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
          }
        } else {
          const Comp = React.lazy(() => import('@Views/app/' + url + '/' + url));
          const menuUrl = url + '/' + url;
          const path = '/' + url;

          if (json[key]['lang'].indexOf(language) === -1) {
            continue;
          }

          if (params) {
            for (const param of params) {
              const paramPath = path + param;
              result.push(<Route exact key={paramPath} path={paramPath} render={() => <Comp url={path} msg={getMsg(menuUrl)} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
            }
          }

          result.push(<Route key={path} exact path={path} render={() => <Comp url={path} msg={getMsg(menuUrl)} userInfo={userInfo} setUserInfo={setUserInfo} />} />);
        }
      }
    }

    result.push(<Route key="Employment" exact path="/" render={() => <Employment url={'/Employment'} msg={getMsg("Employment/Employment")} />} />);
    result.push(<Route key="EmploymentWrite" exact path="/EmploymentWrite/:svyrEmplyPbanNo" render={() => <EmploymentWrite url={'/EmploymentWrite'} msg={getMsg("Employment/EmploymentWrite")} />} />);
    result.push(<Route key="NotFound" component={NotFound}></Route>);

    return result;
  }

  const bodyChange = () => {

    const hash = window.location.hash;

  }

  useEffect(() => {
    bodyChange();

    return history.listen((location) => {

      bodyChange();
      if (window.location.href.indexOf('ecostest.bok.or.kr') === -1) {
        ReactGa.send({ hitType: 'pageview', path: location.pathname, location: location.pathname, title: location.pathname });
      }

    })
  }, [history])


  return <>
    <div className={"wrap-body"} ref={bodyRef}>
      <Suspense fallback={<><Loading /></>}>
        <Switch>
          {getRoute()}
        </Switch>
      </Suspense>
    </div>
  </>
}

const Loading = () => {
  return (
    <div className="loading displayNone">
      <div className="loading-visual">
        <div className="image">
          <div className="spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <p className="text">Loading ...</p>
      </div>

      <div className="loading-dim"></div>
    </div>
  )
}

const Routes = () => {
  const { t } = useTranslation();
  const userInfoSession: any = sessionStorage.getItem("userInfo");
  const [userInfo, setUserInfo]: any = useState(JSON.parse(userInfoSession));

  const getMsg = (url?: string) => {
    const comMsg = { "comMsg": t("comMsg", { returnObjects: true }) };

    if (url) {
      return Object.assign(t(url, { returnObjects: true }), comMsg['comMsg']);
    } else {
      return comMsg['comMsg'];
    }
  }

  return (
    <>
      <Toast getMsg={getMsg} />
      <Loading />
      <Router>
        <Header getMsg={getMsg} routesJson={routesJson} userInfo={userInfo} setUserInfo={setUserInfo} />
        <Body getMsg={getMsg} userInfo={userInfo} setUserInfo={setUserInfo} />
        <Footer getMsg={getMsg} />
      </Router>
    </>
  )
}


export default Routes;